<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-100" style="background: rgb(81,112,255);
                  background: linear-gradient(135deg, rgba(81,112,255,1) 0%, rgba(203,12,159,1) 100%);">
        <div class="container">

          <div class="row" style="justify-content: center;">
            
            <div id="logoTomate" class="col-6" style="display: flex;
              justify-content: center;">
              <img src="../assets/img/ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="
              display: block;
              width: auto;"/>
            </div>

            <div class="mx-auto col-xl-6 col-lg-6 col-md-6 d-flex flex-column">

              <div class="container" style="width: fit-content;">
                <div class="card z-index-0">
                  <div class="pb-0 card-header text-start">
                    <h3 class="font-weight-bolder text-success">
                      Welcome back
                    </h3>
                    <p class="mb-0">Enter your email and password to sign in</p>
                  </div>
                  <div class="card-body">
                      <label>Email</label>
                      <input
                        id="email"
                        type="email"
                        class="form-control"
                        name="email"
                        v-model="email"
                        placeholder="Email"
                        isRequired="required"
                      />
                      <label>Password</label>
                      <div>
                        <input
                          id="password"
                          type="password"
                          class="form-control"
                          name="password"
                          v-model="password"
                          placeholder="Password"
                          isRequired="required"
                        />
                        <i style="float: right;
                            left: -7px;
                            cursor: pointer;
                            margin-top: -25px;
                            position: relative;
                            font-size: 12px;
                            z-index: 2;" @mouseover="showPass('#password')" @mouseout="showPass('#password')" class="fa fa-eye"></i>
                      </div>
                      
                      <div class="text-center">
                        
                        <soft-button
                          @click="login()"
                          class="my-4 mb-2"
                          color="success"
                          full-width
                          >
                          <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;
                          Sign in
                        </soft-button>
                      </div>
                      <div>
                        <p class="text-sm mt-3 mb-0">
                          Do not have an account?
                          <!--<router-link
                            :to="{ name: 'Sign Up' }"
                            class="text-dark font-weight-bolder"
                          >
                            Sign up
                          </router-link>-->
                          <a class="text-dark font-weight-bolder" href="/sign-up">Sign up</a>
                        </p>
                        <p class="text-sm mt-3 mb-0">
                          Cannot remember your password?
                          <router-link
                            :to="{ name: 'Reset Password' }"
                            class="text-dark font-weight-bolder"
                          >
                            Reset password
                          </router-link>
                        </p>
                      </div>
                      
                  </div>
                </div>
                <br>
                <!--<soft-alert v-show="wrongCreds === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
                  <strong>Wrong credentials</strong>, try again!
                </soft-alert>-->
                <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-unlike-2 ni-lg" dismissible>
                  <strong> {{ responseMessage }} </strong>
                </soft-alert>
              </div>
              
            </div>
            
          </div>
        </div>
      </div>
    </section>
  </main>

  <app-footer-entrada class="footer" />
</template>

<script>
import AppFooterEntrada from "@/examples/PageLayout/FooterEntrada.vue";
import SoftButton from "@/components/SoftButton.vue";
import SoftAlert from "@/components/SoftAlert.vue";
//const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import router from '../router/index'

export default {
  name: "SignIn",
  components: {
    AppFooterEntrada,
    SoftButton,
    SoftAlert
  },

  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    //body.classList.remove("bg-gray-100");
  },

  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    //body.classList.add("bg-gray-100");
  },

  data() {
    return {
      email: "",
      password: "",
      llamada: new HTFetch(),
      K: new K(),
      wrongCreds: false,
      responseMessage: "",
      showResponseMessage: false,
      loader: false
    }
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    showPass(id) {
      var input = document.querySelector(id)
      let attributeValue = input.getAttribute('type');

      console.log(attributeValue)

      if (attributeValue == "password") {
        input.setAttribute('type', 'text')
      } else {
        input.setAttribute('type', 'password')
      }
    },

    login() {
      
      this.llamada.Login(this.email, this.password, this.loginRsp.bind(this))
      this.loader = true
    },

    loginRsp(rsp) {

      if (rsp.status !== 401 && rsp.status !== 400 && rsp.status !== 403) {
        localStorage.ut = rsp.data.access
        localStorage.rt = rsp.data.refresh
        localStorage.user_logged = 'true'

        //checkeo tipo user
        this.llamada.userInfo(this.userInfoRsp.bind(this))

      } else {
          this.loader = false
          /*this.wrongCreds = true

          setTimeout(() => {
            this.wrongCreds = false
          }, 5000)*/
          if ('detail' in rsp.data) {
            this.responseMessage = rsp.data.detail
          }

          if ('Message' in rsp.data) {
            this.responseMessage = rsp.data.Message
          }

          if ('message' in rsp.data) {
            this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('username' in rsp.data) {
            this.responseMessage = rsp.data.username.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('password' in rsp.data) {
            this.responseMessage = rsp.data.password.toString().replace("'", "").replace("[", "").replace("]", "")
          }

          if ('Error' in rsp.data) {
            this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
          }
          
          this.showResponseMessage = true

          setTimeout(() => {
            this.showResponseMessage = false
          }, 5000)
      }
      
    },

    userInfoRsp(rsp) {
      
      if (rsp.data.manager === true) {
        localStorage.manager = 'true'
      } else {
        localStorage.manager = 'false'
      }
      if (rsp.data.inserter === true) {
        localStorage.inserter = 'true'
      } else {
        localStorage.inserter = 'false'
      }

      localStorage.pack = rsp.data.premium

      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
        collecciones.push({
          "name": Object.keys(rsp.data.collections)[i],
          "token": Object.values(rsp.data.collections)[i]
        })
      }

      localStorage.collections = JSON.stringify(collecciones)
      localStorage.userId = rsp.data.token

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "sign-in",
          user_id: localStorage.userId
        });
      }
      //seteo la variable para mostrar video
      //localStorage.tutorial_watched = rsp.data.tutorial_watched

      this.loader = false

      router.push({ name: 'Database' })
    }
  },
};
</script>
<style scoped>
#logoTomate {
    height: 300px;
  }
@media (max-width: 1000px) {
  #logoTomate {
    height: 250px;
  }
}
@media (min-width: 1000px) {
  #logoTomate {
    height: 300px;
  }
}
@media (max-width: 400px) {
  #logoTomate {
    height: 215px;
  }
}

@media (max-height: 600px) {
  .footer {
    display: none;
  }
}

@media (max-width: 770px) {
  .footer {
    display: none;
  }
}
</style>